import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AbstractSelect } from '@components/field_form/selects/abstract-select';
import { DocumentTypeService } from '@services/admin/document-type.service';
import { AbstractClass } from '@classes/abstract.class';
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import {HiringCompanyService} from "@services/admin/hiring-company.service";

@Component({
  standalone: false,
  selector: 'app-field-form-select-hiring-company',
  templateUrl: './select-hiring-company.component.html',
  styleUrls: ['./select-hiring-company.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'overlay_custom_select' }
    }
  ]
})
export class SelectHiringCompanyComponent extends AbstractSelect implements OnInit {
  @Input() public myClass: AbstractClass | null = null;
  @Input() label = '';
  @Input() name = '';
  @Input() required = false;

  public list: any[] = [];
  public selectTemporal: any[] = [];

  constructor(
    public service: HiringCompanyService
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.loadData();
  }

  public loadData = () => {
    this.service.getAllActive().then(
      (data) => {
        if (data === true) {
          this.list = this.service.data.data;
        }
      }
    );
  }
}
